export default function removeNode(child) {
  if (child) {
    if (child.remove) {
      child.remove();
    } else {
      var parent = child.parentElement;

      if (parent && parent.removeChild) {
        parent.removeChild(child);
      }
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@shazambanking/sdk/util/removeNode.js
// module id = 608
// module chunks = 0